import React from "react";

import MessengerCustomerChat from "react-messenger-customer-chat";

function Messenger() {
  return (
    <div>
      <MessengerCustomerChat
        pageId="103455685784435"
        appId="787123462284202"
        minimized="false"
      />
    </div>
  );
}

export default Messenger;
